<template>
    <div class="about-view" style="margin-left: 360px;width: 1200px;margin-top: 50px;">
        <div style="height: 48px;background: linear-gradient(90deg, #017BD3 0%, #FFFFFF 100%);">
            <img class="cursor" src="../assets/manual/jtou-icon.png" style="margin-left: 32px;margin-top: 17px;    transform: translateY(2px);"  @click="goback">
			<span class="cursor" style="width: 27px;
height: 13px;
font-family: Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #FFFFFF;
margin-left: 11px;" @click="goback">返回</span>
<span class="cursor" style="width: 109px;
height: 13px;
font-family: Microsoft YaHei;
font-weight: 400;
font-size: 15px;
color: #FFFFFF;
margin-left: 20px;" @click="goback">{{active_name}}</span>

        </div>
		<div style="margin-top:20px;min-height: 800px;border: none;border-bottom: 1px solid #ddd;">
			<div style="display: flex;float: left;">
				<img :src="info.image" style="width: 50px;height: 50px;">
			</div>
			<div style="display: flex;">
					<div style="display: table-column;margin-left: 18px;">
					<span style="font-size: 18px;color: #333333;font-weight: bold;">
					{{ info.name }}
					</span>
					<img  v-if="info.from_type_list.indexOf('1') !== -1" src="../assets/manual/iphone.png" style="width:18px;height:18px;margin-left: 17px;" />
					<img  v-if="info.from_type_list.indexOf('2') !== -1" src="../assets/manual/and.png" style="width:18px;height:18px;margin-left: 17px;" />
					<img  v-if="info.from_type_list.indexOf('3') !== -1" src="../assets/manual/bg-ie-browser.png" style="width:18px;height:18px;margin-left: 17px;" />
					<div><span style="color:#666666;font-size:14px;">{{ info.describe }}</span></div>
					</div>
			</div>
			<div  style="margin-left: 62px;margin-top: 29px;" v-html="info.details">
				
			</div>
		</div>

		<div style="height: 70px;">
			<div class="cursor" style="float: left;margin-top: 20px;" v-if="up_info.id>0">
				<span>上一个：</span>
				<span style="font-size: 16px;color: #027BD3;" @click="tode(up_info.id)">{{up_info.name}}</span>
			</div>
			<div  class="cursor" style="float: right;margin-top: 20px;" v-if="below_info.id>0">
				<span>下一个：</span>
				<span  style="font-size: 16px;color: #027BD3;" @click="tode(below_info.id)">{{below_info.name}}</span>
			</div>
		</div>
    </div>
</template>
<script>
export default {
    name: 'AboutView',
    data() {
        return {
           info: {
			},
			below_info:{},
			up_info:{},
			activeId:0,
			active_name:""
        }   
    },
	created() {
		const id = this.$route.query.id;
		const active_name = this.$route.query.active_name;
		const activeId = this.$route.query.activeId;
		this.active_name=decodeURI(active_name);
		this.activeId=activeId;
		console.log(id);
		this.manualInfo(id);
	},
	methods: {
		async manualInfo(id) {
			const response = await fetch(this.$apiBaseUrl+"/api/website/manual_info",{  
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: 'id=' + id
			});
			const data = await response.json();
			this.info=data.data.info
			this.below_info=data.data.below_info;
			this.up_info=data.data.up_info;
			console.log(data.data)			
		},
		tode(id){
			// window.location.href="manualde?id="+id+"&active_name"+encodeURI(this.active_name)
			// this.$router.push("/manualde?id="+id);encodeURI(this.active_name)
			this.$router.push('/manualde?id='+id+"&active_name="+this.active_name+"&activeId="+this.activeId)
			window.location.reload() // 强制刷新
		},
		goback(){
			this.$router.push("/manual?activeId="+this.activeId+"&active_name="+encodeURI(this.active_name));
		}
	}       
}
</script>
<style lang="scss" scoped>
.about-view {
	.cursor{
		cursor:pointer
	}
    .banner-view {
        height: 510px;
        background-image: url('../assets/about/banner.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title-view {
        color: #333;
        font-size: 30px;
        font-weight: bold;
        position: relative;
        &::after {
            height: 4px;
            width: 60px;
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            background-image: url('../assets/about/img.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
    .title-view {
        &~p {
            margin: 0;
            line-height: 38px;
            color: #333;
            text-indent: 32px;
        }
    }
	.title-view2{
		color: #333;
		font-size: 17px;
		font-weight: bold;
	}
    .pic_view {
        width: 540px;
        height: 410px;
        flex: none;
        margin-left: 60px;

        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    .about-box {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 48px;
        margin-bottom: 30px;
        & > div {
            height: 240px;
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(36,82,131,0.1);
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #333;
            .about-icon {
                width: 84px;
                height: 84px;
            }
            .about-title {
                color: #72777C;
                font-size: 14px;
                margin: 20px 0;
            }
        }
    }
    .map-img {
        width: 1200px;
        height: 506px;
        background: #F4E4B0;
        border-radius: 10px;
        margin-bottom: 45px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
    }
}
</style>